// Walk Mode (FPV) state + constants. Pure data — reducer in
// state-machine.ts; pure math in movement.ts; orchestrator wiring
// (pointer-lock, key listeners, frame ticker) in orchestrator.ts.

export const WALK_SPEED = 3.0; // m/s
export const RUN_SPEED = 6.0; // m/s — Shift modifier deferred to 4.M
export const GRAVITY = 9.81; // m/s²
export const JUMP_VELOCITY = 4.0; // m/s
export const MOUSE_SENSITIVITY = 0.002; // rad/pixel

// MVP defaults: assume the splat dataset has Y=0 at floor level.
// Studio editor (post-MVP) will expose `metadata.floorHeight`. Auto-detect
// via 5° percentile of splat Y is deferred to 4.I2.
export const FLOOR_HEIGHT = 0;
export const EYE_HEIGHT = 1.65; // m — matches mockup "altezza 1.65m"

// Clamp pitch to avoid gimbal flip at the poles.
export const PITCH_MAX = Math.PI / 2 - 0.01;

// Distance from floor below which we consider the player "on the floor"
// for jump eligibility (after gravity clamp).
export const ON_FLOOR_EPSILON = 1e-3;

export interface WalkState {
  active: boolean;
  eyeHeight: number;
  floorHeight: number;
}

export type WalkEvent = { type: 'TOGGLE_ACTIVE' } | { type: 'EXIT' };

export interface WalkSnapshot {
  active: boolean;
  eyeHeight: number;
  floorHeight: number;
}
